/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';

//custom style
import style from "../../Styles/Component/input.module.scss";

//Custom components
import { Icon } from '../Icon';

const CustomSearchInput = (props) => {

    const [isInputFocused, setIsInputFocused] = useState(false);

    // handle focus 
    const _handleFocus = () => {
        setIsInputFocused(true);
    };

    const _handleBlur = () => {
        setIsInputFocused(false);
    };

    //input handle change
    const _handleChange = (e) => {
        let value = e.target.value;
        props.handleChange(value);
    };

    // handle enter key press
    const keyPress = (e) => {
        if (e.keyCode === 13) {
            props.onKeyPress();
        }
    };

    const _handleKeyDown = (e) => {
        // Prevent default behavior of up and down arrow keys
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
        }
        if (props.type === "number") {
            if (e.key === '0' && props.value === '') {
                e.preventDefault();
            }
        }
        if (e.key === '.' && props.not_decimal) {
            e.preventDefault();
        }
    };
    return (
        <div ref={props.ref} className={props.wrapperClassName} id='search-input'>
            <div className={`${style.e_input_wrapper} w-100`}>
                {props.label &&
                    <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-alt-font-lato e-font-weight-400 line-height-20px padding-8px-bottom`}>
                        {props.label}
                        {props.require &&
                            <span className='e-text-vermilion'>*</span>
                        }
                    </label>
                }
                <div className={` ${isInputFocused ? `${style.e_active} ` : `${style.e_inactive_search} ${props.borderStyle}`} border-radius-100 position-relative overflow-auto no-scrollbar w-100`}>
                    <input id={props.id}
                        ref={props.ref}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type={props.type}
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${style.e_input_search} ${props.className} padding-40px-left e-padding-16px-right-res padding-58px-right padding-10px-tb border-0 border-radius-100 e-bg-white e-font-16 e-text-chinese-black e-font-weight-400 line-height-20px e-alt-font-lato w-100`}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        // onKeyDown={(e) => keyPress(e)}
                        onKeyDown={(e) => {
                            keyPress(e);
                            _handleKeyDown(e);
                        }} />

                    <Icon icon="search"
                        size="1rem"
                        className=" position-absolute left-16px top-13px d-flex"
                        onPress={_handleFocus} />

                    {
                        props.value &&
                        <span className='e-bg-ocean-blue position-absolute end-0 top-0 px-3 h-100 d-flex align-items-center cursor-pointer'
                            onClick={props.handleOnSearch}>
                            <Icon icon="right-arrow"
                                size="1rem"
                                color="#F7F5FF"
                                className="d-flex" />
                        </span>
                    }
                </div>
            </div>
        </div >
    )

}
CustomSearchInput.defaultProps = {
    onKeyPress: () => { },
    handleOnSearch: () => { },
    className: null,
    error: "",
}

export default memo(CustomSearchInput);